import React, { Component } from "react";

import {
  RiAddLine,
  RiArrowRightSLine,
  RiCloseLine,
  RiFolder3Line,
  RiFolderOpenLine,
  RiQuestionLine,
  RiSearchLine,
  RiStackLine
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { setObj } from "../../../../actions/noteActions";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import "./style.css";

/* Administração do FAQ: o conteúdo do chatbot e da tela /faq.

   Cria, edita e apaga áreas, tópicos e dúvidas, e define quais perfis
   enxergam cada item. Quem vê o quê é decidido no backend
   (FaqVisibilidadeService): o perfil precisa estar marcado no item E em todos
   os níveis acima dele, e item sem perfil não aparece para ninguém. Esta tela
   só grava as marcações e avisa quando uma delas não vai ter efeito.

   Mostra sempre a árvore inteira, inclusive o que não tem perfil marcado
   (selo "sem perfil"). Já houve aqui um "Visualizar como", com a árvore como
   cada perfil a recebe; saiu em 02/10/2026 por não ser necessário — os perfis
   de cada item aparecem no próprio editor e ao parar o mouse sobre ele.

   Restrita ao Administrador Educandus (perfil 1 ativo). O backend confere o
   mesmo em cada chamada; o bloqueio daqui só evita mostrar uma tela que não
   funcionaria. Acesso pelo menu Cadastros > FAQ (/helpdesk/faq/list).

   Mora nesta pasta, e não numa própria, porque a rota /helpdesk/faq/list já
   existe em todos os bancos apontando para Help/Faq/List (configuration_links).
   Assim a tela nova entrou sem mudança de banco. Até outubro/2026 aqui ficava
   a listagem de 2021, que quebrou quando o chatbot passou a gravar texto puro
   na mesma tabela; o formulário dela (Help/Faq/Create) saiu junto, e as rotas
   /helpdesk/faq/form e /helpdesk/faq/edit/:id ficaram sem página.

   A pasta pages/FaqAdmin, que existiu em develop entre agosto e outubro de
   2026, nunca teve rota no banco — o conteúdo dela é este.

   MERGE COM ALFA: alfa ainda tem pages/FaqAdmin. Num conflito, mantenha esta
   versão e apague aquela pasta. */

const ROLE_ADMIN_EDUCANDUS = 1;

const FORM_VAZIO = {
  name: "",
  description: "",
  question: "",
  answer: "",
  navigation_path: "",
  action_label: "",
  action_url: "",
  role_ids: [],
  home_role_ids: []
};

class FaqAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      tree: [],
      perfis: [],
      abertos: {},
      selecao: null,
      form: FORM_VAZIO,
      carregandoItem: false,
      salvando: false,
      filtro: ""
    };
  }

  componentDidMount() {
    this.montado = true;
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    if (this.podeEditar()) {
      this.carregarPerfis();
      this.carregarArvore(true);
    }
  }

  /* O perfil ativo pode chegar ao redux depois da montagem; sem isto, quem
     entrasse direto pela URL ficaria na mensagem de acesso restrito. */
  componentDidUpdate(prevProps) {
    if (
      this.podeEditar() &&
      ((prevProps.general || {}).active_roles || {}).role_id !==
        this.roleId() &&
      !this.state.tree.length
    ) {
      this.carregarPerfis();
      this.carregarArvore(true);
    }
  }

  componentWillUnmount() {
    this.montado = false;
  }

  setSafeState(patch) {
    if (this.montado) {
      this.setState(patch);
    }
  }

  roleId() {
    return ((this.props.general || {}).active_roles || {}).role_id;
  }

  podeEditar() {
    return this.roleId() === ROLE_ADMIN_EDUCANDUS;
  }

  config(params = {}) {
    return {
      headers: { authorization: `Bearer ${this.props.user.token}` },
      params: { role_id: this.roleId(), ...params }
    };
  }

  falha(error, padrao) {
    const dados = error && error.response && error.response.data;
    toastr.error("Falha", (dados && dados.error) || padrao);
  }

  /* Perfis globais (sem group_id): são os que existem para todos os clientes,
     e o FAQ é o mesmo para todos. */
  carregarPerfis() {
    axios.get(`${URL.api}access/role/list`, this.config()).then(
      res => {
        const perfis = ((res.data && res.data.data) || [])
          .filter(perfil => !perfil.group_id && !perfil.deleted_at)
          .sort((a, b) => a.id - b.id)
          .map(perfil => ({ id: perfil.id, name: perfil.name }));

        this.setSafeState({ perfis });
      },
      error => this.falha(error, "Não foi possível carregar os perfis.")
    );
  }

  carregarArvore(primeiraVez) {
    this.setState({ loading: primeiraVez });

    return axios
      .get(`${URL.api}helpdesk/faqTheme/tree`, this.config({ all: 1 }))
      .then(res => {
        if (!res.data || !res.data.success) {
          throw recusa(res);
        }

        /* As áreas começam recolhidas: com a contagem de dúvidas ao lado,
           as cinco cabem na tela de uma vez e dão o mapa do conteúdo. */
        this.setSafeState({ tree: res.data.data || [], loading: false });
      })
      .catch(error => {
        this.falha(error, "Não foi possível carregar o conteúdo do FAQ.");
        this.setSafeState({ loading: false });
      });
  }

  alternarNo(id) {
    this.setState(prev => ({
      abertos: { ...prev.abertos, [`t-${id}`]: !prev.abertos[`t-${id}`] }
    }));
  }

  /* --------------------------------------------------------- seleção */

  selecionarTema(id) {
    const achado = encontrarTema(this.state.tree, id);

    if (!achado) {
      return;
    }

    const { no } = achado;

    this.setState({
      selecao: { tipo: "tema", id },
      form: {
        ...FORM_VAZIO,
        name: no.name || "",
        description: no.description || "",
        role_ids: no.role_ids || [],
        home_role_ids: no.home_role_ids || []
      }
    });
  }

  selecionarFaq(faq) {
    this.setState({
      selecao: { tipo: "faq", id: faq.id },
      carregandoItem: true,
      form: { ...FORM_VAZIO, question: faq.question }
    });

    axios
      .get(`${URL.api}helpdesk/faq/singleView/${faq.id}`, this.config())
      .then(res => {
        const dados = (res.data && res.data.data) || {};

        this.setSafeState({
          carregandoItem: false,
          form: {
            ...FORM_VAZIO,
            question: dados.question || "",
            answer: dados.answer || "",
            navigation_path: dados.navigation_path || "",
            action_label: dados.action_label || "",
            action_url: dados.action_url || "",
            role_ids: dados.role_ids || []
          }
        });
      })
      .catch(error => {
        this.falha(error, "Não foi possível carregar essa dúvida.");
        this.setSafeState({ carregandoItem: false, selecao: null });
      });
  }

  /* Um item novo já nasce com os perfis de onde ele entra: é o caso comum,
     e evita criar algo que ninguém vê por esquecimento. */
  novoTema(paiId) {
    this.setState(prev => {
      const pai = paiId ? encontrarTema(prev.tree, paiId) : null;

      return {
        selecao: { tipo: "novoTema", paiId: paiId || null },
        form: {
          ...FORM_VAZIO,
          role_ids: pai ? alcance(pai.caminho) : []
        }
      };
    });
  }

  novaFaq(temaId) {
    const tema = encontrarTema(this.state.tree, temaId);

    this.setState(prev => ({
      selecao: { tipo: "novaFaq", temaId },
      abertos: { ...prev.abertos, [`t-${temaId}`]: true },
      form: {
        ...FORM_VAZIO,
        role_ids: tema ? alcance(tema.caminho) : []
      }
    }));
  }

  alterarCampo(campo, valor) {
    this.setState(prev => ({ form: { ...prev.form, [campo]: valor } }));
  }

  alternarPerfil(campo, id) {
    this.setState(prev => {
      const atuais = prev.form[campo];
      const marcados =
        atuais.indexOf(id) === -1
          ? atuais.concat([id])
          : atuais.filter(item => item !== id);

      const form = { ...prev.form, [campo]: marcados };

      // Área inicial só existe para quem enxerga a área.
      if (campo === "role_ids") {
        form.home_role_ids = prev.form.home_role_ids.filter(
          item => marcados.indexOf(item) !== -1
        );
      }

      return { form };
    });
  }

  /* --------------------------------------------------------- gravação */

  salvar() {
    const { selecao, form } = this.state;

    if (!selecao) {
      return;
    }

    const ehTema = selecao.tipo === "tema" || selecao.tipo === "novoTema";

    if (ehTema && !form.name.trim()) {
      toastr.warning("Atenção", "Informe o nome.");
      return;
    }

    if (!ehTema && (!form.question.trim() || !form.answer.trim())) {
      toastr.warning("Atenção", "Pergunta e resposta não podem ficar vazias.");
      return;
    }

    if (!form.role_ids.length) {
      toastr.warning(
        "Atenção",
        "Marque ao menos um perfil. Sem perfil, ninguém vê o item."
      );
      return;
    }

    const { url, corpo } = this.requisicao(selecao, form);

    this.setState({ salvando: true });

    axios
      .post(`${URL.api}${url}`, corpo, this.config())
      .then(res => {
        if (!res.data || !res.data.success) {
          throw recusa(res);
        }

        toastr.success("Pronto", "Alterações salvas.");

        const novoId = res.data.data;
        let selecaoNova = selecao;

        if (selecao.tipo === "novoTema") {
          selecaoNova = { tipo: "tema", id: novoId };
        } else if (selecao.tipo === "novaFaq") {
          selecaoNova = { tipo: "faq", id: novoId };
        }

        return this.carregarArvore(false).then(() => {
          this.setSafeState({ salvando: false, selecao: selecaoNova });

          if (selecaoNova.tipo === "tema") {
            this.selecionarTema(selecaoNova.id);
          }
        });
      })
      .catch(error => {
        this.falha(error, "Não foi possível salvar.");
        this.setSafeState({ salvando: false });
      });
  }

  requisicao(selecao, form) {
    const perfis = { role_ids: form.role_ids };

    if (selecao.tipo === "novoTema" || selecao.tipo === "tema") {
      const raiz =
        selecao.tipo === "novoTema"
          ? !selecao.paiId
          : this.state.tree.some(area => area.id === selecao.id);

      const corpo = {
        name: form.name,
        description: form.description,
        ...perfis,
        ...(raiz ? { home_role_ids: form.home_role_ids } : {})
      };

      return selecao.tipo === "novoTema"
        ? {
            url: "helpdesk/faqTheme/insert",
            corpo: { ...corpo, parent_id: selecao.paiId }
          }
        : {
            url: `helpdesk/faqTheme/update/${selecao.id}`,
            corpo: { ...corpo, id: selecao.id }
          };
    }

    const corpo = {
      question: form.question,
      answer: form.answer,
      navigation_path: form.navigation_path,
      action_label: form.action_label,
      action_url: form.action_url,
      ...perfis
    };

    return selecao.tipo === "novaFaq"
      ? {
          url: "helpdesk/faq/insert",
          corpo: { ...corpo, theme_id: selecao.temaId }
        }
      : {
          url: `helpdesk/faq/update/${selecao.id}`,
          corpo: { ...corpo, id: selecao.id }
        };
  }

  excluir() {
    const { selecao, tree } = this.state;

    if (!selecao || (selecao.tipo !== "tema" && selecao.tipo !== "faq")) {
      return;
    }

    let pergunta = "Excluir esta dúvida?";

    if (selecao.tipo === "tema") {
      const achado = encontrarTema(tree, selecao.id);
      const { topicos, duvidas } = contar(achado ? achado.no : {});
      const partes = [];

      if (topicos) {
        partes.push(`${topicos} ${topicos === 1 ? "tópico" : "tópicos"}`);
      }
      if (duvidas) {
        partes.push(`${duvidas} ${duvidas === 1 ? "dúvida" : "dúvidas"}`);
      }

      pergunta = partes.length
        ? `Excluir "${achado.no.name}"? Também serão excluídos ${partes.join(
            " e "
          )} que estão dentro dele.`
        : `Excluir "${achado.no.name}"?`;
    }

    if (!window.confirm(pergunta)) {
      return;
    }

    const url =
      selecao.tipo === "tema"
        ? `helpdesk/faqTheme/delete/${selecao.id}`
        : `helpdesk/faq/delete/${selecao.id}`;

    this.setState({ salvando: true });

    axios
      .post(`${URL.api}${url}`, { id: selecao.id }, this.config())
      .then(res => {
        if (!res.data || !res.data.success) {
          throw recusa(res);
        }

        toastr.success("Pronto", "Item excluído.");
        return this.carregarArvore(false);
      })
      .then(() => {
        this.setSafeState({ salvando: false, selecao: null, form: FORM_VAZIO });
      })
      .catch(error => {
        this.falha(error, "Não foi possível excluir.");
        this.setSafeState({ salvando: false });
      });
  }

  nomeDoPerfil(id) {
    const perfil = this.state.perfis.find(item => item.id === Number(id));

    return perfil ? perfil.name : `Perfil ${id}`;
  }

  /* --------------------------------------------------------- árvore */

  expandirTudo() {
    const abertos = {};
    const marcar = nos =>
      nos.forEach(no => {
        abertos[`t-${no.id}`] = true;
        marcar(no.children || []);
      });

    marcar(this.state.tree);
    this.setState({ abertos });
  }

  recolherTudo() {
    this.setState({ abertos: {} });
  }

  /* Clicar no nome seleciona e também abre — fechar fica com a seta, para
     um clique de leitura não esconder o que a pessoa acabou de abrir. */
  abrirTema(no) {
    this.setState(prev => ({
      abertos: { ...prev.abertos, [`t-${no.id}`]: true }
    }));

    this.selecionarTema(no.id);
  }

  perfisDoItem(item) {
    const ids = item.role_ids || [];

    return ids.length
      ? `Quem visualiza: ${ids.map(id => this.nomeDoPerfil(id)).join(", ")}`
      : "Sem perfil marcado: ninguém vê";
  }

  /* `livre`: um nível acima casou com a busca pelo nome, então este nó entra
     inteiro — buscar "Turmas" mostra o tópico com tudo o que tem dentro. */
  renderTema(no, nivel, livre = false) {
    const { abertos, selecao, filtro } = this.state;
    const termo = livre ? "" : normalizar(filtro);
    const nomeCasa = !!termo && normalizar(no.name).indexOf(termo) !== -1;

    if (termo && !contemTermo(no, termo)) {
      return null;
    }

    const filhos = no.children || [];
    const faqs = (no.faqs || []).filter(
      faq =>
        !termo || nomeCasa || normalizar(faq.question).indexOf(termo) !== -1
    );
    const temConteudo = filhos.length > 0 || faqs.length > 0;
    const buscando = !!normalizar(filtro);
    const aberto =
      temConteudo &&
      (Boolean(abertos[`t-${no.id}`]) || (buscando && !nomeCasa && !livre));
    const ativo = selecao && selecao.tipo === "tema" && selecao.id === no.id;
    const semPerfil = !(no.role_ids || []).length;
    const { duvidas } = contar(no);
    const Icone =
      nivel === 0 ? RiStackLine : aberto ? RiFolderOpenLine : RiFolder3Line;

    return (
      <div key={`t-${no.id}`} className="faq-admin__node">
        <div
          className={`faq-admin__item faq-admin__item--n${Math.min(nivel, 2)}${
            ativo ? " is-active" : ""
          }`}
        >
          {temConteudo ? (
            <button
              type="button"
              className={`faq-admin__toggle${aberto ? " is-open" : ""}`}
              onClick={() => this.alternarNo(no.id)}
              aria-label={`${aberto ? "Recolher" : "Expandir"} ${no.name}`}
              aria-expanded={aberto}
            >
              <RiArrowRightSLine size={18} />
            </button>
          ) : (
            <span className="faq-admin__toggle" />
          )}
          <button
            type="button"
            className="faq-admin__label"
            onClick={() => this.abrirTema(no)}
            title={this.perfisDoItem(no)}
          >
            <Icone className="faq-admin__icon" size={nivel === 0 ? 17 : 16} />
            <span className="faq-admin__name">{no.name}</span>
          </button>
          {semPerfil && (
            <span className="faq-admin__badge faq-admin__badge--warn">
              sem perfil
            </span>
          )}
          <span className="faq-admin__count">{duvidas}</span>
        </div>

        {aberto && (
          <div className="faq-admin__children">
            {faqs.map(faq => this.renderFaq(faq))}
            {filhos.map(filho =>
              this.renderTema(filho, nivel + 1, livre || nomeCasa)
            )}
          </div>
        )}
      </div>
    );
  }

  renderFaq(faq) {
    const { selecao } = this.state;
    const ativo = selecao && selecao.tipo === "faq" && selecao.id === faq.id;
    const semPerfil = !(faq.role_ids || []).length;

    return (
      <div
        key={`q-${faq.id}`}
        className={`faq-admin__item faq-admin__item--faq${
          ativo ? " is-active" : ""
        }`}
      >
        <span className="faq-admin__toggle" />
        <button
          type="button"
          className="faq-admin__label"
          onClick={() => this.selecionarFaq(faq)}
          title={this.perfisDoItem(faq)}
        >
          <RiQuestionLine className="faq-admin__icon" size={15} />
          <span className="faq-admin__name">{faq.question}</span>
        </button>
        {semPerfil && (
          <span className="faq-admin__badge faq-admin__badge--warn">
            sem perfil
          </span>
        )}
      </div>
    );
  }

  renderBusca() {
    const { filtro } = this.state;
    const termo = normalizar(filtro);
    const encontradas = termo
      ? contarEncontradas(this.state.tree, termo)
      : null;

    return (
      <div className="faq-admin__toolbar">
        <div className="faq-admin__search">
          <RiSearchLine className="faq-admin__search-icon" size={16} />
          <input
            type="text"
            className="form-control"
            placeholder="Buscar área, tópico ou dúvida"
            aria-label="Buscar área, tópico ou dúvida"
            value={filtro}
            onChange={e => this.setState({ filtro: e.target.value })}
          />
          {filtro && (
            <button
              type="button"
              className="faq-admin__search-clear"
              onClick={() => this.setState({ filtro: "" })}
              aria-label="Limpar busca"
            >
              <RiCloseLine size={16} />
            </button>
          )}
        </div>
        <div className="faq-admin__toolbar-row">
          <span className="faq-admin__toolbar-info">
            {encontradas === null
              ? "Clique em um item para editar."
              : `${encontradas} ${
                  encontradas === 1
                    ? "dúvida encontrada"
                    : "dúvidas encontradas"
                }`}
          </span>
          {!termo && (
            <span className="faq-admin__toolbar-actions">
              <button type="button" onClick={() => this.expandirTudo()}>
                Expandir tudo
              </button>
              <button type="button" onClick={() => this.recolherTudo()}>
                Recolher
              </button>
            </span>
          )}
        </div>
      </div>
    );
  }

  renderArvore() {
    const { tree } = this.state;

    const termo = normalizar(this.state.filtro);

    if (termo && !tree.some(area => contemTermo(area, termo))) {
      return (
        <div className="faq-admin__empty">
          Nada encontrado. Tente outra palavra.
        </div>
      );
    }

    return tree.map(area => this.renderTema(area, 0));
  }

  /* --------------------------------------------------------- editor */

  /* Perfis que alcançam o lugar onde o item está. Marcar um perfil fora
     desse alcance não tem efeito — restrição só estreita. */
  alcanceDoPai() {
    const { selecao, tree } = this.state;

    if (!selecao) {
      return null;
    }

    if (selecao.tipo === "tema") {
      const achado = encontrarTema(tree, selecao.id);
      return achado && achado.caminho.length > 1
        ? alcance(achado.caminho.slice(0, -1))
        : null;
    }

    if (selecao.tipo === "novoTema") {
      const pai = selecao.paiId ? encontrarTema(tree, selecao.paiId) : null;
      return pai ? alcance(pai.caminho) : null;
    }

    const temaId =
      selecao.tipo === "novaFaq" ? selecao.temaId : temaDaFaq(tree, selecao.id);
    const tema = temaId ? encontrarTema(tree, temaId) : null;

    return tema ? alcance(tema.caminho) : null;
  }

  renderPerfis() {
    const { perfis, form } = this.state;
    const permitidos = this.alcanceDoPai();
    const semEfeito = permitidos
      ? form.role_ids.filter(id => permitidos.indexOf(id) === -1)
      : [];

    return (
      <div className="faq-admin__field">
        <span className="faq-admin__field-label">Quem visualiza</span>
        <div className="faq-admin__checks">
          {perfis.map(perfil => (
            <label key={perfil.id} className="faq-admin__check">
              <input
                type="checkbox"
                checked={form.role_ids.indexOf(perfil.id) !== -1}
                onChange={() => this.alternarPerfil("role_ids", perfil.id)}
              />
              {perfil.name}
            </label>
          ))}
        </div>
        {!form.role_ids.length && (
          <small className="faq-admin__hint faq-admin__hint--warn">
            Sem perfil marcado, ninguém vê este item.
          </small>
        )}
        {semEfeito.length > 0 && (
          <small className="faq-admin__hint faq-admin__hint--warn">
            {semEfeito.map(id => this.nomeDoPerfil(id)).join(", ")}{" "}
            {semEfeito.length === 1 ? "não está marcado" : "não estão marcados"}{" "}
            no nível acima. Para{" "}
            {semEfeito.length === 1 ? "esse perfil" : "esses perfis"}, este item
            não vai aparecer.
          </small>
        )}
      </div>
    );
  }

  renderAreaInicial() {
    const { form } = this.state;

    if (!form.role_ids.length) {
      return null;
    }

    return (
      <div className="faq-admin__field">
        <span className="faq-admin__field-label">
          Abrir o chatbot nesta área para
        </span>
        <div className="faq-admin__checks">
          {form.role_ids.map(id => (
            <label key={id} className="faq-admin__check">
              <input
                type="checkbox"
                checked={form.home_role_ids.indexOf(id) !== -1}
                onChange={() => this.alternarPerfil("home_role_ids", id)}
              />
              {this.nomeDoPerfil(id)}
            </label>
          ))}
        </div>
        <small className="faq-admin__hint">
          Cada perfil abre em uma área só: marcar aqui desmarca a área que ele
          tinha antes. Quem não tiver área inicial começa pela lista de áreas.
        </small>
      </div>
    );
  }

  renderEditorTema() {
    const { selecao, form, tree } = this.state;
    const raiz =
      selecao.tipo === "novoTema"
        ? !selecao.paiId
        : tree.some(area => area.id === selecao.id);

    return (
      <>
        <div className="faq-admin__field">
          <label htmlFor="faq-nome" className="faq-admin__field-label">
            Nome
          </label>
          <input
            id="faq-nome"
            type="text"
            className="form-control"
            maxLength={255}
            value={form.name}
            onChange={e => this.alterarCampo("name", e.target.value)}
          />
        </div>

        <div className="faq-admin__field">
          <label htmlFor="faq-apoio" className="faq-admin__field-label">
            Texto de apoio (opcional)
          </label>
          <input
            id="faq-apoio"
            type="text"
            className="form-control"
            maxLength={255}
            value={form.description}
            onChange={e => this.alterarCampo("description", e.target.value)}
          />
          <small className="faq-admin__hint">
            Aparece abaixo do nome, no botão do chatbot.
          </small>
        </div>

        {this.renderPerfis()}
        {raiz && this.renderAreaInicial()}
      </>
    );
  }

  renderEditorFaq() {
    const { form } = this.state;

    return (
      <>
        <div className="faq-admin__field">
          <label htmlFor="faq-pergunta" className="faq-admin__field-label">
            Pergunta
          </label>
          <input
            id="faq-pergunta"
            type="text"
            className="form-control"
            value={form.question}
            onChange={e => this.alterarCampo("question", e.target.value)}
          />
        </div>

        <div className="faq-admin__field">
          <label htmlFor="faq-resposta" className="faq-admin__field-label">
            Resposta
          </label>
          <textarea
            id="faq-resposta"
            className="form-control"
            rows={7}
            value={form.answer}
            onChange={e => this.alterarCampo("answer", e.target.value)}
          />
        </div>

        <div className="faq-admin__field">
          <label htmlFor="faq-caminho" className="faq-admin__field-label">
            Onde fica (opcional)
          </label>
          <input
            id="faq-caminho"
            type="text"
            className="form-control"
            value={form.navigation_path}
            onChange={e => this.alterarCampo("navigation_path", e.target.value)}
            placeholder="Menu lateral > Biblioteca > Meus Favoritos"
          />
        </div>

        <div className="faq-admin__pair">
          <div className="faq-admin__field">
            <label htmlFor="faq-botao" className="faq-admin__field-label">
              Texto do botão (opcional)
            </label>
            <input
              id="faq-botao"
              type="text"
              className="form-control"
              maxLength={255}
              value={form.action_label}
              onChange={e => this.alterarCampo("action_label", e.target.value)}
              placeholder="Acessar direcionamento"
            />
          </div>
          <div className="faq-admin__field">
            <label htmlFor="faq-link" className="faq-admin__field-label">
              Link do botão (opcional)
            </label>
            <input
              id="faq-link"
              type="url"
              className="form-control"
              maxLength={255}
              value={form.action_url}
              onChange={e => this.alterarCampo("action_url", e.target.value)}
              placeholder="https://"
            />
          </div>
        </div>

        {this.renderPerfis()}
      </>
    );
  }

  /* Onde o item está (ou vai entrar), da área até o nó acima dele — para a
     pessoa saber em que lugar da árvore está mexendo. */
  caminhoDoEditor() {
    const { selecao, tree } = this.state;
    const nomes = caminho => caminho.map(no => no.name);

    if (selecao.tipo === "tema") {
      const achado = encontrarTema(tree, selecao.id);
      return achado ? nomes(achado.caminho.slice(0, -1)) : [];
    }

    const paiId =
      selecao.tipo === "novoTema"
        ? selecao.paiId
        : selecao.tipo === "novaFaq"
        ? selecao.temaId
        : temaDaFaq(tree, selecao.id);
    const pai = paiId ? encontrarTema(tree, paiId) : null;

    return pai ? nomes(pai.caminho) : [];
  }

  tituloDoEditor() {
    const { selecao } = this.state;

    if (selecao.tipo === "novoTema") {
      return selecao.paiId ? "Novo tópico" : "Nova área";
    }

    if (selecao.tipo === "novaFaq") {
      return "Nova dúvida";
    }

    return selecao.tipo === "faq" ? "Editar dúvida" : "Editar área ou tópico";
  }

  /* O card do editor tem a mesma estrutura em qualquer estado — cabeçalho,
     corpo que rola por dentro e, editando, o rodapé com as ações — para ficar
     sempre com a mesma altura do card da árvore, ao lado. */
  renderEditor() {
    const { selecao, carregandoItem, salvando } = this.state;

    const vazio = texto => (
      <>
        <div className="faq-admin__panel-header">
          <span className="faq-admin__panel-title">Edição</span>
        </div>
        <div className="faq-admin__panel-body faq-admin__panel-body--empty">
          <div className="faq-admin__empty">{texto}</div>
        </div>
      </>
    );

    if (!selecao) {
      return vazio(
        "Escolha um item na lista para editar. Para criar uma dúvida ou um tópico, selecione primeiro a área ou o tópico onde ele vai entrar."
      );
    }

    if (carregandoItem) {
      return vazio("Carregando...");
    }

    const ehTema = selecao.tipo === "tema" || selecao.tipo === "novoTema";
    const existente = selecao.tipo === "tema" || selecao.tipo === "faq";
    const caminho = this.caminhoDoEditor();

    return (
      <>
        <div className="faq-admin__panel-header">
          <div className="faq-admin__editor-heading">
            {caminho.length > 0 && (
              <div className="faq-admin__path">{caminho.join(" › ")}</div>
            )}
            <span className="faq-admin__panel-title">
              {this.tituloDoEditor()}
            </span>
          </div>
          {selecao.tipo === "tema" && (
            <div className="faq-admin__editor-tools">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => this.novaFaq(selecao.id)}
              >
                <RiAddLine size={15} /> Dúvida
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => this.novoTema(selecao.id)}
              >
                <RiAddLine size={15} /> Tópico
              </button>
            </div>
          )}
        </div>

        <div className="faq-admin__panel-body">
          {ehTema ? this.renderEditorTema() : this.renderEditorFaq()}
        </div>

        <div className="faq-admin__actions">
          {existente && (
            <button
              type="button"
              className="btn btn-outline-danger"
              disabled={salvando}
              onClick={() => this.excluir()}
            >
              Excluir
            </button>
          )}
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={salvando}
            onClick={() => this.setState({ selecao: null, form: FORM_VAZIO })}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            disabled={salvando}
            onClick={() => this.salvar()}
          >
            {salvando ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </>
    );
  }

  render() {
    const { loading } = this.state;

    if (!this.podeEditar()) {
      return (
        <div className="p-5 text-center text-muted">
          Esta tela é restrita ao Administrador Educandus.
          <ProtectedRoute routeId={this.props.currentRoute} />
        </div>
      );
    }

    return (
      <div className="faq-admin w-100">
        <div className="faq-admin__header">
          <div>
            <h4 className="faq-admin__title">FAQ e Chatbot</h4>
            <p className="faq-admin__subtitle">
              Conteúdo do chatbot e da tela de perguntas frequentes.
            </p>
          </div>
        </div>

        {loading ? (
          <div className="faq-admin__empty">Carregando conteúdo...</div>
        ) : (
          <div className="faq-admin__grid">
            <div className="faq-admin__panel faq-admin__panel--tree">
              <div className="faq-admin__panel-header">
                <span className="faq-admin__panel-title">Conteúdo</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => this.novoTema(null)}
                >
                  <RiAddLine size={15} /> Nova área
                </button>
              </div>
              {this.renderBusca()}
              <div className="faq-admin__tree">{this.renderArvore()}</div>
            </div>

            <div className="faq-admin__panel faq-admin__panel--editor">
              {this.renderEditor()}
            </div>
          </div>
        )}

        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

/* Resposta com success: false vira erro com o mesmo formato de um erro do
   axios, para cair no mesmo .catch e mostrar a mensagem do backend. */
function recusa(res) {
  const erro = new Error("Recusado pelo servidor");
  erro.response = res;
  return erro;
}

/* Sem acento e em minúsculas, para o filtro casar com o que se digita. */
const normalizar = texto =>
  String(texto || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

function contemTermo(no, termo) {
  if (normalizar(no.name).indexOf(termo) !== -1) {
    return true;
  }

  const naPropria = (no.faqs || []).some(
    faq => normalizar(faq.question).indexOf(termo) !== -1
  );

  return naPropria || (no.children || []).some(f => contemTermo(f, termo));
}

/* Quantas dúvidas casam com a busca — pela pergunta, ou por estarem dentro
   de um tópico cujo nome casa. */
function contarEncontradas(nos, termo) {
  return nos.reduce((total, no) => {
    if (!contemTermo(no, termo)) {
      return total;
    }

    if (normalizar(no.name).indexOf(termo) !== -1) {
      return total + contar(no).duvidas;
    }

    const proprias = (no.faqs || []).filter(
      faq => normalizar(faq.question).indexOf(termo) !== -1
    ).length;

    return total + proprias + contarEncontradas(no.children || [], termo);
  }, 0);
}

/* Nó pelo id, com o caminho da área até ele (o próprio nó por último). */
function encontrarTema(nos, id, caminho = []) {
  for (let i = 0; i < nos.length; i += 1) {
    const no = nos[i];
    const atual = caminho.concat([no]);

    if (no.id === id) {
      return { no, caminho: atual };
    }

    const achado = encontrarTema(no.children || [], id, atual);
    if (achado) {
      return achado;
    }
  }

  return null;
}

function temaDaFaq(nos, faqId) {
  for (let i = 0; i < nos.length; i += 1) {
    const no = nos[i];

    if ((no.faqs || []).some(faq => faq.id === faqId)) {
      return no.id;
    }

    const achado = temaDaFaq(no.children || [], faqId);
    if (achado) {
      return achado;
    }
  }

  return null;
}

/* Perfis marcados em todos os nós do caminho — é quem alcança o fim dele. */
function alcance(caminho) {
  return (
    caminho.reduce(
      (acc, no) =>
        acc === null
          ? (no.role_ids || []).slice()
          : acc.filter(id => (no.role_ids || []).indexOf(id) !== -1),
      null
    ) || []
  );
}

function contar(no) {
  let topicos = 0;
  let duvidas = (no.faqs || []).length;

  (no.children || []).forEach(filho => {
    const sub = contar(filho);
    topicos += 1 + sub.topicos;
    duvidas += sub.duvidas;
  });

  return { topicos, duvidas };
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setObj }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqAdmin);
